/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateForExamSynevoDto
 */
export interface CreateForExamSynevoDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateForExamSynevoDto
     */
    supportingExaminationDictIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateForExamSynevoDto interface.
 */
export function instanceOfCreateForExamSynevoDto(value: object): value is CreateForExamSynevoDto {
    return true;
}

export function CreateForExamSynevoDtoFromJSON(json: any): CreateForExamSynevoDto {
    return CreateForExamSynevoDtoFromJSONTyped(json, false);
}

export function CreateForExamSynevoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateForExamSynevoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'supportingExaminationDictIds': json['supportingExaminationDictIds'] == null ? undefined : json['supportingExaminationDictIds'],
    };
}

export function CreateForExamSynevoDtoToJSON(value?: CreateForExamSynevoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'supportingExaminationDictIds': value['supportingExaminationDictIds'],
    };
}

